import { toast } from "sonner";

// Robust copy that also works in INSECURE contexts (http:// on a raw IP / LAN), where
// navigator.clipboard is undefined. Falls back to a hidden textarea + execCommand.
export async function copyText(text, label = "Copied") {
  const value = String(text ?? "");
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(value);
    } else {
      const ta = document.createElement("textarea");
      ta.value = value;
      ta.style.position = "fixed";
      ta.style.top = "-9999px";
      ta.setAttribute("readonly", "");
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    if (label) toast.success(label);
    return true;
  } catch (e) {
    toast.error("Copy failed — please select and copy manually");
    return false;
  }
}
